import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CircularProgress, Grid } from '@material-ui/core'; // Cambiado a Material-UI
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types'; // Importación de PropTypes
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  version: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.versionUko.colorVersionLabel,
    bottom: '15px',
    left: '50%',
    right: '0',
    textAlign: 'center',
    position: 'static',
  },
  mainComponent: {
    minHeight: '100vh',
    backgroundColor: theme.palette.secondary.light,
  }
}));

const LogoutBemyself = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  
  const queryParams = new URLSearchParams(location.search);
  const crId = queryParams.get('crId');

  useEffect(() => {
    const timer = setTimeout(() => {
      history.push('/login');
    }, 1000);
    return () => clearTimeout(timer);
  }, [crId, history]);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.mainComponent}
    >
      <Box style={{ textAlign: 'center' }}>
        <CircularProgress size={50} color="secondary" />
      </Box>
    </Grid>
  );
};

LogoutBemyself.propTypes = {
  appName: PropTypes.string.isRequired,
  getVersionAppAction: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutBemyself);
